<script setup>
import {defineModel, defineEmits, defineProps, computed} from 'vue'
import YandexDirectSVG from "@/components/UI/Logos/YandexDirectSVG.vue";
import HowItWorksButton from "@/pages/CreateConnection/HowItWorksButton.vue";
import ToolTip from "@/components/UI/ToolTip.vue";
import GoogleSheetsRawSvg from "@/components/UI/svg/GoogleSheetsRawSvg.vue";
import YandexSheetsSvg from "@/components/UI/svg/YandexSheetsSvg.vue";
import VKAdsSvg from "@/components/UI/svg/services/VKAdsSvg.vue";
import BitrixLogo from "@/components/UI/svg/services/BitrixLogo.vue";


const type = defineModel()
const emits = defineEmits(['selectType'])
const typeOptionsSource = [
    {
        value: 'GOOGLE_SHEETS',
        label: 'Google Sheets',
        icon: GoogleSheetsRawSvg,
        iconSize: 'size-10',
        toolTip: 'Выгрузите данные из Google Таблицы'
    },
    {
        value: 'YANDEX_DIRECT_STAT',
        label: 'Статистика Яндекс Директ',
        icon: YandexDirectSVG,
        iconSize: 'size-8 h-10 mr-1',
        toolTip: 'Получите данные из рекламного кабинета Yandex Direct'
    },
    {
        value: 'VKONTAKTE_CAMPAIGN_STAT',
        label: 'Статистика VK Рекламы',
        icon: VKAdsSvg,
        iconSize: 'size-8 h-10 mr-1',
        toolTip: 'Получите данные из рекламного кабинета VK'
    },
    {
        value: 'BITRIX_UPLOAD',
        label: 'Данные из Битрикс24',
        icon: BitrixLogo,
        iconSize: 'size-10',
        toolTip: 'Получите данные из рекламного кабинета VK'
    },
]

const typeOptionsTarget = [
    {
        value: 'GOOGLE_SHEETS',
        label: 'Google Sheets',
        icon: GoogleSheetsRawSvg,
        iconSize: 'size-10',
        toolTip: 'Загрузите данные в Google Таблицы'
    },
]


const props = defineProps({
    fileType: String
})

const typeOptions = computed(() => {
    if (props.fileType === 'SOURCE') return typeOptionsSource
    if (props.fileType === 'TARGET') return typeOptionsTarget
    return []
})

const soonLoads = [
    {
        value: 'YANDEX_SHEETS',
        label: 'Яндекс Таблицы',
        icon: YandexSheetsSvg,
        iconSize: 'size-8 mr-1',
        isDisabled: true,
    }
]


function selectType(value) {
    type.value = value
    emits('selectType')
}

</script>

<template>
    <div
        class="bg-white shadow-md rounded-3xl h-1/2 min-h-[380px] flex flex-col"
    >
        <div class="flex justify-between p-5 border-b border-gray-100">
            <div class="mx-4">
                <div class="text-sm lg:text-lg font-bold flex items-center justify-start">
                    <div class="mr-2 text-xl my-2" v-if="props.fileType === 'SOURCE'">Выберите источник</div>
                    <div class="mr-2 text-xl my-2" v-else-if="props.fileType === 'TARGET'">Выберите таблицу назначения</div>
                </div>
                <div class="text-sm lg:text-base font-bold text-gray-600">
                    <div class="mr-2 text-lg my-2" v-if="props.fileType === 'SOURCE'">Откуда вы хотите импортировать данные?</div>
                    <div class="mr-2 text-lg my-2" v-else-if="props.fileType === 'TARGET'">Куда вы хотите экспортировать данные?</div>
                </div>
            </div>
            <div class="mr-10">
                <HowItWorksButton />
            </div>

        </div>
        <div class="mt-4 mx-10 flex flex-col gap-5">
            <div class="">
                <div class="text-xs lg:text-sm font-bold text-gray-600">
                    Интеграции
                </div>
            </div>
            <div class="w-full h-full flex gap-5">
                <ToolTip
                    :text="option.toolTip" position="bottom"
                    v-for="option in typeOptions"
                    :key="option.value"
                >

                    <div
                        class="border border-blue-200 px-3 py-2 rounded-md cursor-pointer bg-gray-50 text-gray-600 hover:bg-blue-50 duration-200 transition-all"
                        @click="selectType(option.value)"
                        :class="{
                            'border-blue-500': type === option.value,
                            'border-gray-200': type !== option.value,
                        }"
                    >
                        <div class="w-full h-full flex items-center justify-center">
                                <component
                                    :is="option.icon"
                                    :class="option.iconSize"
                                />

                            <div class="font-bold text-xs ml-1 select-none">
                                {{ option.label }}
                            </div>
                        </div>
                    </div>
                </ToolTip>

                <div
                    v-for="option in soonLoads"
                    :key="option"
                    class="border border-gray-200 px-3 py-2 rounded-md cursor-not-allowed bg-gray-100 text-gray-600 relative"
                >
                    <div class="w-full h-full flex items-center justify-center">
                        <component
                            :is="option.icon"
                            :class="option.iconSize"
                        />
                        <div class="font-bold text-xs ml-1 select-none">
                            {{ option.label }}
                        </div>
                    </div>
                    <div class="font-bold text-xs text-gray-600 absolute bottom-0 right-2">
                        СКОРО
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>